import { forwardRef } from "react";
import { SystemFieldType, SystemPageType } from "../../../../Model/SystemModels";
import { CardField } from "../../../Common/Template/Card/CardField";
import { CardGroup } from "../../../Common/Template/Card/CardGroup";
import PageContainer, { PageContainerBase } from "../../../Common/Template/PageContainer";

export const AdminAIPromptCard = forwardRef<PageContainerBase, React.PropsWithChildren<{}>>((props, ref) => {
    return (
        <PageContainer pageType={SystemPageType.Card} title="Scheda prompt AI" endpoint="odata/ai/prompt" ref={ref}>
            <CardGroup name="general" label="Generale" isOpen={true}>
                <CardField name="code" label="Codice" type={SystemFieldType.String} />
                <CardField name="description" label="Descrizione" type={SystemFieldType.String} />
                <CardField name="content" label="Contenuto" type={SystemFieldType.String}  multiline/>
                <CardField name="temperature" label="Temperatura" type={SystemFieldType.String} />
                <CardField name="searchIndexName" label="Nome indice di ricerca" type={SystemFieldType.String} hasTableRelation tableRelationEndpoint="/odata/ai/search/index" tableRelationKey="name" tableRelationField="name" />
                <CardField name="citationFormat" label="Formato citazione" type={SystemFieldType.Option} cmbOptions={[
                    {key: 0, text: "Markdown"},
                    {key: 10, text: "HTML"}
                ]} />
                <CardField name="oaiApiDeploymentName" label="Nome distribuzione api" type={SystemFieldType.String} />
            </CardGroup>
        </PageContainer>
    );
});